import { useEffect, useState } from "react";

import { useAppSelector } from "../app/hooks";
import { fetchDeadAccountKillerInfo } from "../helper/deadAccountKiller";
import useWallet from "../hook/useWallet";
import { DeadAccountKillerInfo } from "../types/DeadAccountKillerInfo";

export const useDeadAccountKiller = () => {
  const { account } = useWallet();
  const { myProfile, profileNames } = useAppSelector((state) => state.profile);
  const [killerInfo, setKillerInfo] = useState<DeadAccountKillerInfo | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadKillerInfo = async () => {
      setIsLoading(true);

      try {
        const info = await fetchDeadAccountKillerInfo(
          account,
          myProfile?.name,
          profileNames
        );

        if (!cancelled) {
          setKillerInfo(info);
        }
      } catch {
        if (!cancelled) {
          setKillerInfo(null);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadKillerInfo();

    return () => {
      cancelled = true;
    };
  }, [account, myProfile?.name, profileNames]);

  return { killerInfo, isLoading };
};
